<template>
  <el-dialog
    id='setCollecAccountDialog'
    :title="title"
    @close="closeDialog"
    :visible.sync="isShow"
    width="620px"
    :close-on-click-modal='false'
    :close-on-press-escape='false'
  >
    <div id="setCollecAccount" v-loading = 'loading'>
      <template v-if="active=='setting'">
        <div class="" style="text-align:left;padding: 0px 0px 10px 0px;">
          <el-alert class="alert" title="" type="info" show-icon :closable="false" style="padding: 8px">
            <span>温馨提示：店铺收款账号设置后，产生的快速理赔款将直接打款至店铺对应的支付宝账号中</span>
          </el-alert>
        </div>
        <div>
          <div>
            <span class="y-fc-F35252">*</span>
            <span class="y-fc-333">当前账号授权店铺：</span>
          </div>
          <div style="position: relative;">
            <span style="position: absolute;top: 13px;display: block;left: 40px;z-index: 11;">全选</span>
            <el-table
              ref="multipleTable"
              :data="tableData"
              style="width: 100%"
              max-height="500"
              @selection-change="handleSelectionChange">
              <el-table-column type="selection" width="55" align="center"></el-table-column>
              <el-table-column width="250">
                <template slot-scope="scope">
                  <div class="y-f y-f-js y-a">
                    <svg-icon v-if="PLATFORMICONMAP[scope.row.platformCode]" :iconClass="PLATFORMICONMAP[scope.row.platformCode]" class="custom-table-list-svg y-mr-5 y-f-shrink"></svg-icon>
                    <span class="y-fl-18">{{scope.row.mallName}}<span v-if="scope.row.isApplyArtificialUnbind">（待解绑）</span></span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="alipayRealName" class="alipayRealName-style">
                <template slot-scope="scope">
                  <div class="y-f y-f-jb y-f-a">
                    <template>
                      <span class=" y-f-shrink">收款人姓名：</span>
                      <span>{{scope.row.alipayRealName}}</span>
                    </template>
                    <el-popover
                      width="100"
                      trigger="click"
                      :content="newRealName">
                      <img slot="reference" src="@/assets/images/view-blue.png" class="view-img-style y-f-shrink" v-if="!!scope.row.alipayRealName" @click.prevent.stop="viewRealName(scope.row)"/>
                    </el-popover>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div class="button-group y-f y-f-jc y-mt-15" v-if="mallStatus == '1'">
          <el-button class="y-w-100 y-mr-20" @click="closeDialog">取消</el-button>
          <el-button class="y-w-100" type="primary" @click="toNext('setAccount')">去设置</el-button>
        </div>
        <div class="button-group y-f y-f-jc y-mt-15" v-else>
          <el-button class="y-w-100 y-mr-20" @click="toNext('unBindAccount')">解绑</el-button>
          <el-button class="y-w-100" type="primary" @click="toNext('upAccount')">修改账号</el-button>
        </div>
      </template>
      <template v-if="active=='setAccount'">
        <set-account :setAccountInfo='setAccountInfo' @close="closeDialog" @next='next'></set-account>
      </template>
      <template v-if="active=='upAccount' || active=='unBindAccount'">
        <up-account :upAccountInfo='upAccountInfo' @close="closeDialog" @next='next'></up-account>
      </template>
      <template v-if="active=='applyUnbind'">
        <apply-unbind :applyUnbindInfo="applyUnbindInfo" @close="closeDialog" @next='next'></apply-unbind>
      </template>
      <template v-if="active=='success'">
        <verify-succeeded :activeType='activeType' :authCode="authCode" @close="closeDialog" @toSetting='toSetting'></verify-succeeded>
      </template>
    </div>
    <el-dialog
      width="580px"
      title="提示"
      :visible.sync="innerVisible"
      @close="closeInnerDialog"
      append-to-body>
      <div class="" style="text-align:left;padding: 0px 0px 10px 0px;">
        <el-alert class="alert" title="" type="info" show-icon :closable="false" style="padding: 8px">
          <span>温馨提示：点击去解绑后您所勾选的店铺支付宝账号将全部解绑并且为空，请谨慎操作！</span>
        </el-alert>
      </div>
      <div class="y-f y-f-jc y-f-a y-mt-20 y-mb-20"><i class="el-icon-warning y-fc-E6A23C y-fs-24 y-mr-10"></i>{{innerInfo.message}}</div>
      <div class="button-group y-f y-f-jc">
        <el-button class="y-w-100 y-mr-20" type="primary" @click="unBindAccountByDialog(innerInfo)">去解绑</el-button>
        <el-button class="y-w-100" @click="closeInnerDialog">取消</el-button>
      </div>
    </el-dialog>
  </el-dialog>
</template>

<script>
import Cookies from 'js-cookie';
import timeText from '@/mixins/timeText';
import { PLATFORMNAMEMAP, PLATFORMICONMAP } from '@/utils/globalConfig';
import {
  getFillAlipayNameByQuicksettlementApi,
  setAliPayAccountByQuicksettlementApi,
  updateAliPayAccountByQuicksettlementApi,
  initUnbindAliPayAccountByQuicksettlementApi,
} from '../../../api/quickIndemnity/quicksettlement';
import verifySucceeded from './verifySucceeded.vue';
import applyUnbind from './applyUnbind.vue';
import SetAccount from './setAccount.vue';
import UpAccount from './upAccount.vue';

export default {
  name: 'setCollecAccountDialog',
  components: { verifySucceeded,applyUnbind,SetAccount, UpAccount },
  mixins: [timeText],
  props: {
    data: {
      type: Object,
      default:{
        title: '店铺收款账号设置',
        mallList: []
      }
    },
    value: {
      type: Boolean,
      default: false
    }
  },
  data() {
    let specStrKey = (rule, value, callback) => {
      if (!/^[\u4e00-\u9fa5 0-9()（）]*$/.test(value)) {
        callback(new Error('姓名仅支持汉字、数字、（）'));
      } else {
        callback();
      }
    };
    let specStr = (rule, value, callback) => {
      // eslint-disable-next-line no-useless-escape
      if (!/^[a-zA-Z0-9\@.]*$/.test(value)) {
        callback(new Error('账号仅支持字母、数字、@ . '));
      } else {
        callback();
      }
    };
    return {
      PLATFORMNAMEMAP,
      PLATFORMICONMAP,
      active: 'setting',
      mallStatus: '1',
      timeText: '获取验证码',
      title: '店铺收款账号设置',
      isShow: this.value,
      loading: false,
      src: '',
      tableData: this.data.mallList,
      multipleSelection: [],
      newRealName:'',
      setAccountInfo:{},
      upAccountInfo:{},
      authCode:'',
      applyUnbindInfo:{},
      innerVisible: false,
      innerInfo:{}
    };
  },
  computed: {
    userMess() {
      return this.$store.state.user;
    }
  },
  created() {
    let time = Cookies.get('smsCode6');
    if (time) {
      let showTime = 60 - parseInt((new Date().getTime() - new Date(time).getTime()) / 1000);
      this.timeText = showTime;
      this.setText();
    }
  },
  mounted() {
    let payList = (this.tableData && this.tableData.length) ? this.tableData.filter(t => t.payAccountId) : [];
    if(payList && payList.length){
      this.mallStatus = '2';
    }else{
      this.mallStatus = '1';
    }
  },
  methods: {
    toSetting(){
      this.isShow = false;
      this.$emit('close');
      this.$parent.openCollecAccount();
    },
    next(activeType,data,flag){
      if(flag==2){
          let info = JSON.parse(data);
          this.upAccountInfo = {
            authCode:info.authCode||'', 
            mobile:info.mobile||'',
            active:activeType||'',
            haveNextVerifyMobileOperate:false,
            flag:2
          }
          this.upAccountInfo = {...this.upAccountInfo}
          this.active = '';
          this.active = activeType;
      }else{
        if(activeType == 'upOrUnBindToApplyUnbind'){
          this.active = 'applyUnbind';
          this.title = '店铺收款账号解绑申请';
          this.applyUnbindInfo = data;
        }else if(activeType == 'unBindAccount'){
          this.active = 'success';
          this.authCode = '';
          this.activeType = activeType;
        }else{
          this.toVerifySucceeded(data,activeType);
        }
      }
    },
    toVerifySucceeded(data,activeType){
      this.active = 'success';
      this.authCode = JSON.parse(data).authCode;
      this.activeType = activeType;
    },
    toNext(code){
      if(this.multipleSelection && this.multipleSelection.length){
        let mallIds = this.multipleSelection.filter(t => t.mallId).map(r=> r.mallId);
        let isApplyArtificialUnbind = this.multipleSelection.filter(t => t.isApplyArtificialUnbind).map(r=> r.isApplyArtificialUnbind);
        if(isApplyArtificialUnbind && isApplyArtificialUnbind.length){
          this.$message.error('待解绑状态店铺，不允许重新绑定支付宝账号，请联系合作网点及时处理！');
          return false;
        }
        if(code=='setAccount'){
          if(this.multipleSelection.length>1){
            this.$confirm('您是否要将多个店铺设置为同一个收款账户!', '提示', {
              confirmButtonText: '去设置',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              this.setAccount(mallIds.join())
            }).catch(() => {});
          }else{
            this.setAccount(mallIds.join())
          }
        }else if(code=='upAccount'){
          this.upAccount(mallIds.join())
        }else if(code=='unBindAccount'){
          this.unBindAccount(mallIds.join())
        }
      }else{
        this.$message.error('请至少勾选一项！');
      }
    },
    setAccount(mallIds){
      setAliPayAccountByQuicksettlementApi(mallIds).then(res => {
        if (res.status == 200 && res.data) {
          let info = JSON.parse(res.data);
          this.setAccountInfo = {
            authCode:info.authCode, 
            mobile:info.mobile,
            active:'setAccount'
          }
          this.active = 'setAccount';
        } else {
          this.$message.error(res.error);
        }
      });
    },
    upAccount(mallIds){
      updateAliPayAccountByQuicksettlementApi(mallIds).then(res => {
        if (res.status == 200 && res.data) {
          let info = JSON.parse(res.data);
          console.log(info.message)
          if(info.message){
            this.$confirm(info.message, '提示', {
              confirmButtonText: '去修改',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              if(info.haveNextVerifyMobileOperate){
                this.upAccountInfo = {
                  authCode:info.authCode, 
                  mobile:info.mobile,
                  haveNextVerifyMobileOperate:info.haveNextVerifyMobileOperate,
                  active:'upAccount',
                  flag:1
                }
              }else{
                this.upAccountInfo = {
                  authCode:info.authCode, 
                  mobile:info.mobile,
                  haveNextVerifyMobileOperate:false,
                  active:'upAccount',
                  flag:2
                }
              }
              
              this.active = 'upAccount';
              this.title = '店铺收款账号修改';
            }).catch(() => {});
          }else{
            if(info.haveNextVerifyMobileOperate){
              this.upAccountInfo = {
                authCode:info.authCode, 
                mobile:info.mobile,
                haveNextVerifyMobileOperate:info.haveNextVerifyMobileOperate,
                active:'upAccount',
                flag:1
              }
            }else{
              this.upAccountInfo = {
                authCode:info.authCode, 
                mobile:info.mobile,
                haveNextVerifyMobileOperate:false,
                active:'upAccount',
                flag:2
              }
            }
            this.active = 'upAccount';
            this.title = '店铺收款账号修改';
          }
        } else {
          this.$message.error(res.error);
        }
      });
    },
    closeInnerDialog(){
      this.innerVisible = false;
      this.innerInfo = {};
    },
    unBindAccountByDialog(info){
      this.innerVisible = false;
      if(info.haveNextVerifyMobileOperate){
        this.upAccountInfo = {
          authCode:info.authCode, 
          mobile:info.mobile,
          haveNextVerifyMobileOperate:info.haveNextVerifyMobileOperate,
          active:'unBindAccount',
          flag:1
        }
      }else{
        this.upAccountInfo = {
          authCode:info.authCode, 
          mobile:info.mobile,
          haveNextVerifyMobileOperate:false,
          active:'unBindAccount',
          flag:2
        }
      }
      this.active = 'unBindAccount';
      this.title = '店铺收款账号解绑';
    },
    unBindAccount(mallIds){
      initUnbindAliPayAccountByQuicksettlementApi(mallIds).then(res => {
        if (res.status == 200 && res.data) {
          let info = JSON.parse(res.data);
          if(info.message){
            this.innerVisible = true;
            this.innerInfo = info;
          }else{
            if(info.haveNextVerifyMobileOperate){
              this.upAccountInfo = {
                authCode:info.authCode, 
                mobile:info.mobile,
                haveNextVerifyMobileOperate:info.haveNextVerifyMobileOperate,
                active:'unBindAccount',
                flag:1
              }
            }else{
              this.upAccountInfo = {
                authCode:info.authCode, 
                mobile:info.mobile,
                haveNextVerifyMobileOperate:false,
                active:'unBindAccount',
                flag:2
              }
            }
            this.active = 'unBindAccount';
            this.title = '店铺收款账号解绑';
          }
        } else {
          this.$message.error(res.error);
        }
      });
    },
    //获取支付宝支付账号的完整真实姓名
    viewRealName(row){
      let params = {
        id: row.payAccountId,
        mallCode: row.mallCode,
        platformCode: row.platformCode,
      }
      getFillAlipayNameByQuicksettlementApi(params).then(res => {
        if (res.status==200 && res.message == 'ok') {
          this.newRealName = res.data || '';
        } else {
          this.newRealName = '';
        }
      }).catch((err) => {
         this.newRealName = '';
      });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    closeDialog() {
      this.isShow = false;
      this.$emit('close');
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" rel="stylesheet/scss">
#setCollecAccountDialog{
  .el-dialog__body{
    padding: 12px 20px 40px 20px;
  }
  .el-table th, .el-table th.el-table__cell{
    background: #fff;
  }
  .el-table td.el-table__cell {
    border: 1px solid #EBEEF5;
  }
  .el-popover__reference-wrapper{
    display: flex;
  }
  .view-img-style{
    width: 16px;
    height: 16px;
    margin-left: 10px;
    display: inline-block;
    cursor: pointer;
  }
  .demo-ruleForm{
    .el-form-item--small.el-form-item{
      // width: 350px;
      margin: 0 auto 18px auto;
    }
    .phone-input .el-input{
      width: 246px;
    }
    .code-input .el-input{
      width: 152px;
    }
    .code-input .el-form-item__content{
      display: flex;
    }
    .code-btn{
      width: 88px;
      height: 32px;
      margin-left: 8px;
      cursor: pointer;
    }
    .form-btn{
      display: block;
      margin-left: 0;
      margin-top: 40px!important;
      text-align: center;
    }
  }
}
</style>
